.ko{min-width:14rem;}